module.exports = __webpack_public_path__ + "static/rock-cba393d7f79b6db57e595cdfd0672106.mp3";